import InfoChip from 'assets/info_gray_chip.svg?react';
import MaskGradientIcon from 'assets/mask_gradient_icon.svg?react';
import OrangeHistoryIcon from 'assets/orange_history_icon.svg?react';
import NiceModal from "components/modals/NiceModal";
import styled from "styled-components";
import useQueryParams from 'utils/useQueryParams';


interface IPaidInfoModalProps {
  isVisible: boolean;
  onClose: () => void;
  paidType: 'premium' | 'token'
}

const PaidInfoModal: React.FC<IPaidInfoModalProps> = (props) => {
  const { isVisible, onClose, paidType } = props;

  const { clearQueryParams } = useQueryParams();
  const handleClose = () => {
    onClose();
    clearQueryParams();
  };

  const isPremiumPaidType = paidType === 'premium';
  const isTokenPaidType = paidType === 'token';


  const getTitleByType = () => {
    if (isPremiumPaidType) {
      return 'Your Premium subscription is now processing';
    }
    if (isTokenPaidType) {
      return 'Your tokens are on the way!';
    }
  };

  const getSubtitleByType = () => {
    if (isPremiumPaidType) {
      return 'Most of the time it\'s just 5–10 minutes, but sometimes it might take up to an hour.';
    }
    if (isTokenPaidType) {
      return 'This usually takes 5–10 minutes, but in rare cases, it can take up to an hour.';
    }
  };

  const getInfoSectionByType = () => {
    if (isPremiumPaidType) {
      return 'If your Premium access hasn\'t been activated after that time, please contact our support team for assistance.';
    }
    if (isTokenPaidType) {
      return 'If your tokens haven\'t arrived after that time, please contact our support team for assistance.';
    }
  };
  return (
    <NiceModal isVisible={isVisible} onClose={handleClose}>
      <Root>
        {isPremiumPaidType && <MaskGradientIcon />}
        {isTokenPaidType && <OrangeHistoryIcon />}
        <Title>{getTitleByType()}</Title>
        <Subtitle>{getSubtitleByType()}</Subtitle>
        <InfoSection>
          <InfoChip width={16} height={16} />
          {getInfoSectionByType()}
        </InfoSection>
        <Wrapper>
          {isPremiumPaidType && (
            <PremiumGradientButton onClick={handleClose}>
              Continue
            </PremiumGradientButton>
          )}
          {isTokenPaidType && (
            <Button onClick={handleClose}>
              Continue
            </Button>
          )}
        </Wrapper>
      </Root>
    </NiceModal>
  );
};

export default PaidInfoModal;

const Root = styled.div`
  width: 380px;
  padding: 24px;
  box-sizing: border-box;
  font-family: "Nunito Sans";
  font-optical-sizing: auto;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 410px) {
    width: unset;
  }

  svg {
    width: 48px;
    height: 48px;
  }
`;

const Wrapper = styled.div`
  font-family: 'Unbounded', sans-serif;
  font-optical-sizing: auto;
  width: 100%;
  display: flex;
  gap: 16px;
`;

const Title = styled.div`
  font-family: Raleway; 
  text-align: center;
  margin: 24px 0 8px 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;

const Subtitle = styled.div`
  font-family: "Nunito Sans";
  color: white;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  margin-bottom: 24px;
`;

const InfoSection = styled.div`
  display: flex;
  gap: 8px;
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #A9A9A9;
  margin-bottom: 32px;
  svg {
    max-width: 16px;
    max-height: 16px;
  }
`;

const Button = styled.div<{ disabled?: boolean }>`
  background: #ff7e55;
  border-radius: 1000px;
  color: white;
  font-weight: bold;
  padding: 0 32px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  cursor: pointer;
  font-family: Nunito Sans;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;
  flex: 1;

  :hover {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 0.8)};
  }
`;

const PremiumGradientButton = styled.button`
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 1000px;
  font-family: 'Nunito Sans', sans-serif;
  color: #fff;
  font-family: Nunito Sans;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  background: linear-gradient(90deg, #9E5EEE 0%, #B759EA 33%, #C65DE9 66%, #B885F4 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  margin: 0 auto;
  &:hover {
    opacity: 0.85;
  }
`;


